import React, { Component } from 'react'

import { RowActionWrapper, RowActionButton, RowActionLink } from './TableRowActions.styles'

class RowAction extends Component {
    handleClick = (evt) => {
      evt.preventDefault()

      this.props.analytics.linkClick({
        text: this.props.dataItem.label,
        type: 'Data Table'
      })

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Table action button click',
        label: this.props.dataItem.label,
        type: 'Data Table'
      })

      if (this.props.dataItem.action) {
        this.props.env.callFunction(this.props.dataItem.action, [this.props.dataRow])
      }
    }

    handleLinkClick = () => {
      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Action Link',
        label: this.props.dataItem.label,
        type: 'Datatable'
      })
    }

    render() {
      return (
        <RowActionWrapper>
          {
            this.props.dataItem && this.props.dataItem.type === 'button' && this.props.dataItem.actionType === 'callback' &&
            <RowActionButton href='/' onClick={this.handleClick}>{this.props.dataItem.label}</RowActionButton>
          }
          {
            this.props.dataItem && this.props.dataItem.type === 'button' && this.props.dataItem.actionType === 'link' &&
            <RowActionButton onClick={this.handleLinkClick} href={this.props.dataItem.action}>{this.props.dataItem.label}</RowActionButton>
          }
          {
            this.props.dataItem && this.props.dataItem.type === 'link' && this.props.dataItem.actionType === 'callback' &&
            <RowActionLink href='/' onClick={this.handleClick}>{this.props.dataItem.label}</RowActionLink>
          }
          {
            this.props.dataItem && this.props.dataItem.type === 'link' && this.props.dataItem.actionType === 'link' &&
            <RowActionLink onClick={this.handleLinkClick} href={this.props.dataItem.action}>{this.props.dataItem.label}</RowActionLink>
          }
        </RowActionWrapper>
      )
    }
}

export default RowAction
